export default __webpack_public_path__ + "media/brands/google-2b5c6446.png";